import { useQuery } from "@tanstack/react-query";
import CommonService from "../services/CommonService";

export const useCountries = () => {
    return useQuery({
        queryKey: ["countries"],
        queryFn: () => CommonService.getAllCountries().then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
        placeholderData: (prevData) => prevData
    });
};